import { Injectable } from '@angular/core';
import { IAbstractPresenter, ILanguageObject } from '@core/interfaces';
import { Store as StoreModel } from '@core/models';
import { StoreDeliveryCodeEnum } from '../../../enums';
import { IStoresListCallback } from '../../../interfaces';
import { IDeliveryStrategyComponent, IDeliveryStrategyPresenter } from './interfaces';

@Injectable()
export class DeliveryStrategyPresenter
	extends IAbstractPresenter<IDeliveryStrategyComponent>
	implements IDeliveryStrategyPresenter
{
	stores: StoreModel[] = [];
	translations: ILanguageObject = {};
	callback!: IStoresListCallback;

	dispatchActions(): void {}

	suscribeObservers(): void {}

	onSelectStore(store: StoreModel, code: StoreDeliveryCodeEnum): void {
		this.view?.callback?.onSelectStore(store, code);
	}
}
